import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    BoxProps,
    Grid,
    IconButtonProps,
    Box as MuiBox,
    IconButton as MuiIconButton,
    Menu as MuiMenu,
    styled,
    Theme,
    useMediaQuery,
} from "@mui/material";
import React, { useContext, useState } from "react";

import { Legend_Z_Index } from "src/const";
import { LanguageContext } from "src/contexts/language";
import { MapContext } from "src/contexts/map";
import { getIconFromPicto } from "src/utils/category";

const Box = styled(MuiBox)<BoxProps>(({ theme }) => ({
    zIndex: Legend_Z_Index,
    position: "absolute",
    bottom: theme.spacing(2),
    left: theme.spacing(2),
}));

const LegendIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.common.white,
    boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2)",
}));

const Icon = styled(FontAwesomeIcon)<{ color?: string }>(
    ({ theme, color }) => ({
        marginRight: theme.spacing(1),
        color: color || "inherit",
        width: "10%",
    }),
);

const IconButton = styled(MuiIconButton)<IconButtonProps>(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    padding: 0,
}));

const Menu = styled(MuiMenu)<{ ismobile: string }>(({ theme, ismobile }) => ({
    width: JSON.parse(ismobile) ? "90%" : "40%",
    marginTop: `-${theme.spacing(4)}`,
    marginLeft: theme.spacing(2.5),
}));

const Legend = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const { categories } = useContext(MapContext);
    const { language } = useContext(LanguageContext);

    const open = Boolean(anchorEl);

    const handleClick: React.MouseEventHandler<HTMLElement> = (event) => {
        setAnchorEl(event.currentTarget as unknown as HTMLElement);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isMobile = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("md"),
    );

    return (
        <Box>
            <IconButton onClick={handleClick}>
                <LegendIcon icon={faCircleInfo} />
            </IconButton>

            <Menu
                ismobile={isMobile.toString()}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <Grid
                    container
                    display="flex"
                    justifyContent="space-evenly"
                    alignItems="center"
                    spacing={1}
                    p={2}
                    m={1}
                >
                    {categories
                        .filter(
                            (category, _, self) =>
                                category.parent_id != null ||
                                (!self.some(
                                    (child) => child.parent_id === category.id,
                                ) &&
                                    category.parent_id === null),
                        )
                        .map((category) => (
                            <Grid key={category.id} item xs={isMobile ? 6 : 4}>
                                <Icon
                                    icon={getIconFromPicto(category.picto)}
                                    color={category.style.primary_color}
                                />
                                {category.title[language]}
                            </Grid>
                        ))}
                </Grid>
            </Menu>
        </Box>
    );
};

export default Legend;
